import { createFileRoute, Link, useLocation } from '@tanstack/react-router';
import { SettingsShell, settingsItemClass } from '@/components/SettingsShell';
import { CircleUserRound, SunMoon } from 'lucide-react';

export const Route = createFileRoute('/user')({
  component: UserLayout,
});

// Personal settings, split out of /account: what's yours (profile, appearance)
// vs. what the account owns (team, billing, connections, keys, notifications).
const NAV_ITEMS = [
  { to: '/user', label: 'Profile', icon: CircleUserRound, exact: true },
  { to: '/user/appearance', label: 'Appearance', icon: SunMoon, exact: false },
] as const;

function UserLayout() {
  const path = useLocation().pathname;

  return (
    <SettingsShell navLabel="User">
      {NAV_ITEMS.map(({ to, label, icon: Icon, exact }) => {
        const active = exact ? path === to : path.startsWith(to);
        return (
          <Link key={to} to={to} className={settingsItemClass(active)} aria-current={active ? 'page' : undefined}>
            <Icon className="size-4 shrink-0" />
            {label}
          </Link>
        );
      })}
    </SettingsShell>
  );
}
